import styled from 'styled-components';
import { Form } from '@unform/web';

export const WrapperForm = styled(Form)`
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 1.5rem;
  }

  > div:last-child {
    margin-top: 1.5rem;
  }

  p.Mui-error {
    margin-top: 0;
  }
`;
